import { t } from '@lingui/core/macro'
import { usePortalAxios } from '@tecsinapse-org/portal-menu-kit'
import React, { useEffect } from 'react'
import {
  useLocation,
  useNavigate,
  useParams,
  useSearchParams
} from 'react-router-dom'
import { Routes } from '../../core/router/routes'
import { AxiosInstance } from 'axios'

export const DownloadPage = () => {
  const navigate = useNavigate()
  const { id } = useParams()
  const { instance } = usePortalAxios()

  const location = useLocation()
  const [searchParams] = useSearchParams()

  useEffect(() => {
    const returnTo =
      (location.state as { from?: string })?.from ??
      searchParams.get('returnTo') ??
      Routes.HOME

    const registrarDownload = searchParams.get('registrarDownload')

    const fetchDownload = async () => {
      try {
        const response = await (instance as AxiosInstance).get(
          `/api/download/${id}`,
          {
            params:
              registrarDownload !== null ? { registrarDownload } : undefined
          }
        )

        const link = document.createElement('a')
        link.href = response.data
        link.target = '_self'
        link.click()
      } catch (error) {
        console.error(error)
      }
    }

    setTimeout(() => {
      navigate(returnTo, { replace: true })
    }, 3000)
    fetchDownload()
  }, [id])

  return (
    <div>
      <div className='flex flex-1 items-center justify-between mb-deca'>
        <p className='text-h1 text-secondary-xdark font-bold'>{t`Download Page`}</p>
      </div>
    </div>
  )
}
